import { DeepPartial, RxTemplate } from './rx-template.model';

export const labBrokerDefaultTemplate: DeepPartial<RxTemplate> = {
	templateId: 'labBrokerDefault',
	ui: {
		order: {
			items: {
				dueDate: { disabled: true },
				sendToChange: { requiresConfirmationForReset: true }
			}
		},
		notes: { disabled: true },
		attachments: { disabled: true },
		teethDiagram: {
			items: {
				toothEditorProperties: { hidden: true }
			}
		},
		appliance: {
			items: {
				procedureType: { hidden: true },
				upperLowerCard: { hidden: true }
			}
		},
		implantPlanning: {
			items: {
				procedureType: { hidden: true }
			}
		},
		denture: {
			items: {
				// procedureType intentionally absent — visible for Denture/Removable
				stage: { disabled: true },
				mould: { disabled: true },
				shadeSystem: { disabled: true },
				teethShade: { disabled: true },
				gingival: { disabled: true }
			}
		},
		scanOptions: {
			items: {
				procedureType: { hidden: true }
			}
		},
		summaryFooter: {
			// Button text: "Continue to " + selectedLab.thirdPartySettings.ui.continueToNameText
			continueToLabBrokerButton: { hidden: false },
			saveAndContinueLaterButton: { hidden: false }
		},
		modeling: {
			readOnly: true
		}
	},
	behaviors: {
		validation: {
			items: {
				// Auto-populated via CustomRxDefault (TR-102381)
				crownSection: { disabled: true },
				scanBody: { disabled: true },
				dentureDetails: { disabled: true }
			}
		}
	}
};
